"use client"

import { useEffect } from "react"
import { usePathname, useRouter } from "next/navigation"

import { authErrorToQuery, readAuthUrlError } from "@/utils/auth-redirect"

/**
 * When GoTrue fails an OAuth round-trip it redirects to the app `redirectTo`
 * (often `/home`) with `?error=` / `#error=`. Send those to `/error` instead.
 */
export default function AuthErrorCatcher() {
  const pathname = usePathname()
  const router = useRouter()

  useEffect(() => {
    if (!pathname || pathname === "/error" || pathname.startsWith("/auth/callback")) {
      return
    }
    const err = readAuthUrlError(window.location.search, window.location.hash)
    if (!err) return
    router.replace(`/error?${authErrorToQuery(err)}`)
  }, [pathname, router])

  return null
}
